import { createSelector } from 'reselect';

export const getDocumentsById = (state) => state.entities.documents;

export const getFoldersById = (state) => state.entities.folders;

export const getFeedIds = (state, props) => state.feeds.idsBySpaceId[props.spaceId || 'all'] || [];

export const getFeed = createSelector(
  [getDocumentsById, getFoldersById, getFeedIds],
  (documents, folders, ids) => ids.map((idItem) => (idItem.schema === 'folders' ? folders[idItem.id] : documents[idItem.id])),
);


export const getFeedIsLoading = (state, props) => !(state.feeds.isLoading[props.spaceId || 'all'] === false) || false;
